import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppCard from './AppCard';
import CircularProgress from '@mui/material/CircularProgress';
import { Grid, Box, Typography } from '@mui/material';
import { fetchAppsAsync } from '../../redux/reducer/apps/appSlice';

function AppsList() {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const apps = useSelector((state) => state.apps.list);
  const loading = useSelector((state) => state.apps.loading);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchAppsAsync());
    }
  }, [dispatch, isAuthenticated]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography color="text.secondary">Loading applications...</Typography>
      </Box>
    );
  }

  if (!apps || apps.length === 0) {
    return (
      <Box
        sx={{
          textAlign: 'center',
          py: 8,
          px: 2,
        }}
      >
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No applications found
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Create your first application to get started
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {apps.map((app) => (
        <Grid key={app._id} item xs={12} sm={6} md={4} lg={3}>
          <AppCard app={app} />
        </Grid>
      ))}
    </Grid>
  );
}

export default AppsList;
